<template>
  <div class="init-offer-client">
    <v-img src="/images/offer/init-offer.png" class="init-offer-client__image mt-10" />

    <h3 class="init-offer-client__label pt-8 pb-2">
      {{ $t('offer-manager.create.enter-phone-number') }}
    </h3>
    <div class="init-offer-client__search-bar-container">
      <contact-search-bar
        :no-client-subtitle="$t('contact.search-bar.no-client-subtitle-offer')"
        :client-history-text-button="$t('contact.search-bar.see-client-history')"
        :action-found-button-text="$t('buttons.create-client-offer')"
        :is-offer="true"
        :origin="$route.path" />
    </div>
  </div>
</template>
<script>
import ContactSearchBar from '@/components/contact/ContactSearchBar.vue'

export default {
  name: 'InitOfferClientHistory',
  components: {ContactSearchBar},
}
</script>
<style lang="scss">
.init-offer-client {
  padding-bottom: 108px;

  &__image {
    max-width: 160px;
    margin: auto;
    text-align: center;
  }

  &__label {
    text-align: center;
    font: normal normal normal 16px/26px 'ProximaNovaRegular';
    font-size: 16px;
    letter-spacing: 0px;
    color: var(--v-gray-darken4);
  }

  &__search-bar-container {
    width: 391px;
    margin: 0 auto;
  }
}
</style>
